import { apiFetch } from '$lib/api/helpers';
import type { ProjectFileFolder } from '$lib/types/project_file';

const PATH = '/project_file_folders/';

export async function fetchProjectFileFolders(projectId: number, unitId?: number) {
	const params = new URLSearchParams({ project: String(projectId) });
	if (unitId != null) params.set('unit', String(unitId));
	return apiFetch<ProjectFileFolder[]>(`${PATH}?${params.toString()}`);
}

export async function createFolder(project: number, name: string, unit?: number) {
	return apiFetch<ProjectFileFolder>(PATH, {
		method: 'POST',
		body: JSON.stringify({ project, unit, name })
	});
}

export async function renameFolder(id: number, name: string) {
	return apiFetch<ProjectFileFolder>(`${PATH}${id}/`, {
		method: 'PATCH',
		body: JSON.stringify({ name })
	});
}

export async function deleteFolder(id: number) {
	return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}
